import { render } from "./TenantsView.vue?vue&type=template&id=b695f492"
import script from "./TenantsView.vue?vue&type=script&lang=js"
export * from "./TenantsView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__